
export const FETCH_HU_LOCAL_RESULTS = 'FETCH_HU_LOCAL_RESULTS';
export const FETCH_HU_LOCAL_RESULTS_SUCCESS = 'FETCH_HU_LOCAL_RESULTS_SUCCESS';
export const FETCH_HU_LOCAL_RESULTS_FAILURE = 'FETCH_HU_LOCAL_RESULTS_FAILURE';
export const FETCH_HU_LOCAL_RESULTS_FORBIDDEN = 'FETCH_HU_LOCAL_RESULTS_FORBIDDEN';

export const FETCH_HU_LOCAL_APP_RESULTS = 'FETCH_HU_LOCAL_APP_RESULTS';
export const FETCH_HU_LOCAL_APP_RESULT_SUCCESS = 'FETCH_HU_LOCAL_APP_RESULT_SUCCESS';
export const FETCH_HU_LOCAL_APP_RESULTS_COMPLETE = 'FETCH_HU_LOCAL_APP_RESULTS_COMPLETE';
